import { render, staticRenderFns } from "./DocumentarySettlementsGrid.vue?vue&type=template&id=3197d919"
import script from "./DocumentarySettlementsGrid.vue?vue&type=script&lang=js"
export * from "./DocumentarySettlementsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports